/**
 * testimonials.js
 * ---------------
 * Authentic-sounding testimonials from Labora community members.
 * Quotes are specific and personal — not generic marketing copy.
 */

export const testimonials = [
  {
    id: 1,
    quote:
      'I posted a failed experiment on a Friday afternoon, mostly to hold myself accountable. By Monday I had 14 comments — two from people who had seen similar anomalies and one from a statistician who spotted a flaw in my sampling design I\'d completely missed. Labora is what happens when peer review meets social media, in the best possible way.',
    author: 'Elena Vasquez',
    initials: 'EV',
    field: 'Environmental Biology, PhD Candidate',
    institution: 'University of Zurich',
    color: '#52D68A',
    rating: 5,
  },
  {
    id: 2,
    quote:
      'I was documenting my CRISPR work here for six months before I mentioned it to my supervisor. When I finally showed him my Labora project page — the timeline, the failed runs, the community discussions — he said it was the most thorough research log he\'d ever seen from a grad student. That validation came from the public accountability, not from private notes.',
    author: 'James Okafor',
    initials: 'JO',
    field: 'Computational Biology, PhD Student',
    institution: 'Massachusetts Institute of Technology',
    color: '#38BDF8',
    rating: 5,
  },
  {
    id: 3,
    quote:
      'Science has always been a collective endeavour that pretends to be individual. You publish solo-author papers about work that depended on conversations, failures, and colleagues nobody credits. Labora doesn\'t pretend. The collaborative nature is built into the feed, the comments, the live updates. It feels honest in a way that traditional publishing doesn\'t.',
    author: 'Dr. Priya Kapoor',
    initials: 'PK',
    field: 'Observational Astrophysics',
    institution: 'California Institute of Technology',
    color: '#A78BFA',
    rating: 5,
  },
  {
    id: 4,
    quote:
      'I completed my algal plastics project after three years and 94 public updates. Looking back at the timeline, I can see exactly when I almost quit (update #31, if you want to know), when the breakthrough happened (update #67), and every messy step between. That record is worth more to me than the journal paper.',
    author: 'Sofia Reinholt',
    initials: 'SR',
    field: 'Green Chemistry, Postdoctoral Researcher',
    institution: 'Uppsala University',
    color: '#52D68A',
    rating: 5,
  },
  {
    id: 5,
    quote:
      'My TBI study involved 60 adolescents and three years of follow-up. At every difficult moment — ethics complications, participant dropouts, data that refused to make sense — I had a community of followers who kept me grounded. Several were patients or parents of TBI survivors. Their presence reminded me what the work was actually for.',
    author: 'David Nwankwo',
    initials: 'DN',
    field: 'Cognitive Neuroscience, Research Fellow',
    institution: 'University College London',
    color: '#38BDF8',
    rating: 5,
  },
  {
    id: 6,
    quote:
      'In Japan, there is enormous pressure to present only finished, polished work. My supervisor thought I was being reckless when I started sharing raw solar cell data publicly. Eighteen months later, that project has 476 followers and I\'ve been invited to present at three international conferences. The openness was the point.',
    author: 'Yuki Tanaka',
    initials: 'YT',
    field: 'Materials Science & Photovoltaics',
    institution: 'Kyoto University',
    color: '#F59E0B',
    rating: 5,
  },
  {
    id: 7,
    quote:
      'I\'m an undergraduate and I always assumed platforms like this were for "real" scientists. But Labora\'s community showed me that the process of becoming a scientist is as valuable as any result. I started documenting my undergraduate thesis here and got feedback that shaped my entire methodology. I\'m presenting at a conference next month.',
    author: 'Amara Osei',
    initials: 'AO',
    field: 'Biochemistry, Undergraduate',
    institution: 'University of Ghana',
    color: '#52D68A',
    rating: 5,
  },
  {
    id: 8,
    quote:
      'As an independent researcher without institutional affiliation, I had no platform. Peer review was closed to me, conferences were expensive, and nobody read my preprints. Labora gave me an audience, collaborators, and — eventually — an invitation to join a lab as a visiting researcher. Open science is a meritocracy when the gates are down.',
    author: 'Tariq Al-Rashidi',
    initials: 'TA',
    field: 'Computational Chemistry',
    institution: 'Independent Researcher, Jordan',
    color: '#38BDF8',
    rating: 5,
  },
  {
    id: 9,
    quote:
      'I teach high school physics in rural Portugal. Labora has become part of my curriculum — I show students real scientists struggling with real problems in real time. It\'s the best answer I\'ve ever found to "but when will I use this?" Science stops looking like a series of neat textbook facts and starts looking like something humans actually do.',
    author: 'Catarina Ferreira',
    initials: 'CF',
    field: 'Physics Teacher & Science Communicator',
    institution: 'Escola Secundária, Évora',
    color: '#A78BFA',
    rating: 5,
  },
];
